export default "__VITE_ASSET__BbpAHuqD__";